import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'server-response',
  templateUrl: './server-response.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServerResponseComponent {

  @Input() response: any[];
  @Input() status?: number;

  constructor() { }

  objectKeys(obj) {
    return Object.keys(obj);
  }
}
